import {getDecision} from '@s-ui/pde'

import {STEPS} from '../settings.js'
import {handleError} from '../utils.js'

export const getInitialProps = async ({routeInfo, context: {domain, i18n, pde}}) => {
  const config = domain.get('config')
  const {decide} = getDecision(pde)

  const {
    VEHICLE_CONFIGURATOR_PATH: redirectTo,
    VEHICLE_SUGGESTER_BODY_TYPE_PATH_PATTERN: nextPagePath,
    VEHICLE_SUGGESTER_PRICE_RANGE_PAGE_NAME: pageName
  } = config.get('page')

  const {enabled: isPriceModeEnabled} = decide('ff_web_new_vehicle_suggester_price_mode')

  const [error, priceRangeOptionsResponse] = await domain
    .get('get_configurator_price_range_options_vehicles_use_case')
    .execute()

  if (error) {
    return handleError({
      domain,
      i18n,
      error,
      message: 'Error fetching price range options',
      redirectTo
    })
  }

  const priceRangeOptions = isPriceModeEnabled
    ? priceRangeOptionsResponse.getFilterOptionsWithFees()
    : priceRangeOptionsResponse.getFilterOptions()

  return {
    h1: i18n.t('COMMON.SUGGESTER'),
    isPriceModeEnabled,
    nextPagePath,
    priceRangeOptions,
    pageName,
    step: STEPS.PRICE_RANGE,
    previousPagePath: null,
    stepBreadcrumb: i18n.t('COMMON.BUDGET'),
    title: i18n.t('VEHICLE_SUGGESTER.STEP_PRICE_RANGE.TITLE')
  }
}
